import React, { useEffect, useState } from 'react';
import HelpBackIcon from './../../../../../images/helpbackicon.png'
import {Link, useNavigate} from 'react-router-dom'

function Analytics() { 
    const [feedback,setFeedback] = useState(false)
    const navigate= useNavigate();

    return (
        <div style={{backgroundImage:`url("https://res.cloudinary.com/ddvootytq/image/upload/f_auto,q_auto/yovww6fxrbmtzfqlpy0z")`,backgroundPositionX:'-1em',backgroundSize:'100%'}}>

        <div style={{         
        display:'flex',
        flexDirection:'column',
        alignItems:'center',
        zIndex:'1',
        height:'9.63em'
        }}/>

        <div style={{
              backgroundColor:'#F9FCFF',
              width:'100%',
              display:'flex',
              flexDirection:'column',
              alignItems:'center',
              paddingBottom:'5.5em',
              minHeight: '72vh', height: 'auto'
        }}>
            <div style={{
                display:'flex',
                flexDirection:'column',
                alignItems:'flex-start',
                width:'70%',
                paddingTop:'2.5em'
            }}>

                <div style={{
                    display:'flex',
                    flexDirection:'row',
                    alignItems:'center',
                    cursor:'pointer'
                   
                }} onClick={()=>{navigate("/help");setFeedback(false)}}>
                    <img src={HelpBackIcon} style={{width:'1.5em',height:'1.5em',marginRight:'0.25em',cursor:'pointer'}}/>
                    <div className="backTxt">Back</div>
                </div>

                <div className="infoHeader">
                    Understanding Analytics
                </div>

                <div className="infoDescHeader" style={{marginTop:'0em'}}>
                DATA ANALYTICS
                </div>

                <div className="infoDesc">
                N3RVES music distribution platform provides a comprehensive system designed to track, analyze, and report on the performance of music content across various distribution channels. Our system aggregates sales data from each distribution platform, providing detailed insights into revenue generation.
                </div>
                <div className="infoDesc">
                <br/>The analytics tool allows you to break down earnings by artist, album, song, and territory, allowing for a granular understanding of where revenue is coming from. It also calculates and tracks royalties, ensuring that artists, producers, and other stakeholders are compensated accurately according to their agreements.
                </div>
                <div className="infoDesc">
                <br/>With advanced reporting features, users can visualize trends over time, compare performance across different markets, and forecast future earnings based on historical data. The system may also include tools for managing contracts and payments, ensuring that royalties are distributed promptly and transparently. Overall, this data analytics solution empowers stakeholders to make informed decisions, optimize distribution strategies, and maximize revenue potential in the competitive music industry.
                </div>

                <div className="infoDescHeader">
                ANALYTICS DASHBOARD
                </div>
                <div className="infoDesc">
                Our analytics platform provides a centralized dashboard where users can monitor their music's performance across multiple distribution channels such as streaming services, digital stores, and social media platforms. Users can access data on stream counts, downloads, playlist placements, geographic reach, listener demographics, and revenue generated from different sources.
                </div>
                <div className="infoDesc">
                <br/>The dashboard features interactive charts and graphs that help to visualize trends over time, allowing users to see how their music is performing in various markets and how different tracks compare in terms of popularity. 
                </div>
                <div className="infoDesc">
                <br/>Users can also drill down into detailed reports that provide insights into audience engagement, such as the most popular tracks or albums, the impact of specific marketing efforts, and the effectiveness of collaborations or remixes. The data can be segmented by various factors, including region, platform, and listener demographics, to provide a granular view of how different audiences are responding to the music. This is very useful in providing actionable insights to help steer career trajectories. 
                </div>
                <div className="infoDesc">
                <br/>The performance metrics are directly tied to royalty tracking, ensuring that artists and labels receive accurate payments from distributors. This royalty and payment info can be found in the users wallet section. 
                </div>
                <div className="infoDesc">
                Overall, music distribution data analytics empowers users to optimize their distribution strategies, understand their audience better, and maximize their revenue potential in the ever-evolving music industry.
                </div>

                {
                    !feedback &&
                    <div>
                         <div className="infoDesc" style={{marginTop:'6.5em'}}>
                            Was this article helpful?
                            </div>

                            <div style={{display:'flex',flexDirection:'row'}}>
                                <div className="helpfulBtn" onClick={()=>setFeedback(true)}>
                                    YES
                                </div>

                                <div className="helpfulBtn" onClick={()=>setFeedback(true)}>
                                    NO
                                </div>
                            </div>
                    </div>
                }

                {
                    feedback &&
                    
                         <div className="infoDesc" style={{marginTop:'8.5em'}}>
                           Thank you for your feedback
                            </div>

                         
                    
                }
               
            </div>

        </div>
        
        
       
    </div>
    )
}


export default Analytics;